import Button from "../../components/Button/Button";
import Container from "../../components/Container/Container";
import Paragraph from "../../components/Paragraph/Paragraph";
import { NavHashLink } from "react-router-hash-link";

import {
  Wrapper,
  ContainerWrapper,
  BackgroundImage,
  StyledHeading1,
  ButtonsWrapper,
} from "./style";

import image from "../../assets/images/HeroImage.jpg";

const Header = () => {
  return (
    <Wrapper>
      <BackgroundImage
        src={image}
        loading="lazy"
        alt="Konstrukca, budynek, tło nagłówka"
      />
      <Container>
        <ContainerWrapper>
          <StyledHeading1>Z pasji do nowoczesnego budownictwa.</StyledHeading1>
          <Paragraph light="true">
            Prowadzenie inwestycji budowlanych, niezależne doradztwo i opinie
            techniczne w zakresie stolarki budowlanej i szkła realizujemy w
            oparciu o profesjonalizm i z dbałością o każdy detal. Doświadczenie,
            innowacja i pasja - to fundamenty naszej działalności.
          </Paragraph>
          <ButtonsWrapper>
            <NavHashLink to="/#oferta">
              <Button white>Poznaj ofertę</Button>
            </NavHashLink>
            <NavHashLink to="/#onas">
              <Button transparent>O firmie</Button>
            </NavHashLink>
          </ButtonsWrapper>
        </ContainerWrapper>
      </Container>
    </Wrapper>
  );
};

export default Header;
